export default "__VITE_PUBLIC_ASSET__28656ada__"